import fahrzeugtyp from '@ahd/shared/maps/fahrzeugtyp';
import { type DateFormatString } from '../_tools/Date';
import { getIdFirma, getMitarbeiterForSelect, getMwSt, getStandorteForSelect } from '../_tools/Session';
import { type DataGridEnrichedColDef } from '../_tools/datagrid/types';
import { type SelectDataObject } from '../_tools/inputfields/Select';
import { effizienzSteps } from '../components/effizienz';
import sExtColors from './s_ext_colors';
import sExtLackart from './s_ext_lackart';
import sIntAntrieb from './s_int_antrieb';
import sIntBattery from './s_int_battery';
import sIntColors from './s_int_colors';
import sIntGarantie from './s_int_garantie';
import sIntGetriebe from './s_int_getriebe';
import sIntGrundfarbe from './s_int_grundfarbe';
import sIntHersteller from './s_int_hersteller';
import sIntKategorie from './s_int_kategorie';
import sIntPlakette from './s_int_plakette';
import sIntPolster from './s_int_polster';
import sIntSiegel from './s_int_siegel';
import sIntSteuer from './s_int_steuer';
import sIntZustand from './s_int_zustand';
import sVerwendung from './s_verwendung';

const sIntMitarbeiter = getMitarbeiterForSelect();

export const DOORS = 5;
export const HINTS = 7;
export const VORBESITZER = 8;
export const FARBE = 9;
export const HINTSAUS = 10;
export const DAMAGEDESC = 11;
export const NUMBERPLATE = 12;
export const VK = 13;
export const LOCATION = 14;
export const TSN = 15;
export const CHASSIS = 16;
export const GESAMTGEWICHT = 17;
export const ID_MODELL = 18;
export const HUBRAUM = 20;
export const MWST = 21;
export const BATTERY = 22;
export const NUTZLAST = 23;
export const ID_MOTOR = 24;
export const MODELL = 25;
export const LEISTUNG = 26;
export const HSN = 27;
export const POLSTER = 28;
export const HU = 29;
export const ID_AUFBAU = 30;
export const KATEGORIE = 31;
export const LACKART = 32;
export const AUSLIEFERUNG = 33;
export const TAKEIN = 35;
export const ID_HERSTELLER = 36;
export const KM = 38;
export const GARANTIE = 39;
export const EZ = 40;
export const DESIGN = 41;
export const DESIGNNEU = 42;
export const PRICECHANGE = 43;
export const OPTIKOK = 45;
export const NACHAQUISE = 46;
export const PREISOK = 47;
export const HUNEU = 49;
export const VAUDIS = 53;
export const EK = 54;
export const MIETWAGEN = 56;
export const SITZE = 57;
export const SCHADSTOFF = 58;
export const MANUFACTYEAR = 59;
export const SIEGEL = 60;
export const INNENFARBE = 61;
export const VKINETN = 63;
export const GEKAUFT = 64;
export const TAKEINEST = 69;
export const ACHSEN = 70;
export const MODELYEAR = 71;
export const CKEY = 72;
export const KFZBRIEF = 73;
export const EINGANGSCHECK = 74;
export const PARKPLATZ = 75;
export const ANGELEGT = 76;
export const HERSTELLER = 77;
export const TYP = 78;
export const MBVKEY = 79;
export const USEDELSEINFO = 81;
export const ZUSTAND = 82;
export const SCHECKHEFT = 83;
export const LAST_SERVICE = 84;
export const LAST_SERVICE_TEXT = 85;
export const EMISSION = 87;
export const WERKSTATT = 88;
export const TECHNIKOK = 89;
export const AUFBEREITUNG = 90;
export const ADDUSAGE = 92;
export const LACKIEREREI = 93;
export const VALUTA = 94;
export const LACKOK = 97;
export const VERFUEGBAR = 99;
export const VERWENDUNG = 100;
export const STATUS = 102;
export const TRANSFER_PLAN = 104;
export const TAGESZULASSUNG = 105;
export const ANTRIEB = 106;
export const QUELLE = 108;
export const FAHRSCHULE = 109;
export const BASISPREIS = 110;
export const NEUPREIS = 115;
export const BLICKFANG_MOBILE = 118;
export const BREITE = 119;
export const FAHRBEREIT = 121;
export const DATE_RECHNUNG_IN = 122;
export const NUMMER_RECHNUNG_IN = 123;
export const DATE_RECHNUNG_OUT = 124;
export const NUMMER_RECHNUNG_OUT = 125;
export const HOEHE = 126;
export const IDBANKVALUTA = 127;
export const ID_PARENT = 128;
export const KOMMISSION = 129;
export const LAENGE = 130;
export const LIEFERZEIT = 131;
export const MINDERAUSSTATTUNGEN = 133;
export const KOSTEN = 134;
export const TAXI = 137;
export const TRANSFER = 138;
export const UPLOAD = 140;
export const VERKAUFT = 141;
export const WEBVK_PLAN = 144;
export const PLAKETTE = 146;
export const SEITEEINS_MOBILE = 147;
export const ENVKV = 148;
export const TRADEPORT = 149;
export const ID_PAKET = 150;
export const SCHLAFPLAETZE = 151;
export const ID_STANDORT = 152;
export const RADSTAND = 155;
export const ECODE = 156;
export const AKTTYP = 157;
export const BATTERYCAPACITY = 158;
export const WERKSTATT_EX = 161;
export const TECHNIKOK_EX = 162;
export const OLDTIMER = 163;
export const YOUNGTIMER = 164;
export const REIFEN = 171;
export const DATENCHECK = 173;
export const VKMINN = 174;
export const STANDTAGE1_RECHNUNG = 175;
export const STANDTAGE1 = 176;
export const STANDZEIT2 = 177;
export const STANDZEIT = 178;
export const KOSTEN_PLAN = 179;
export const VKMIN_PLAN = 180;
export const HP1_PLAN = 181;
export const HP2_PLAN = 182;
export const DEBITINFO = 183;
export const ZYLINDER = 185;
export const VIRTUELL = 188;
export const ID_GRUNDFARBE = 189;
export const ID_OWNER = 190;
export const DATA_XML = 191;
export const ECE_IN = 192;
export const ECE_COM = 193;
export const ECE_OUT = 194;
export const PORTAL1TEXT = 195;
export const TOPINSERAT_MOBILE = 196;
export const ID_BRIEFSTATUS = 197;
export const ID_USER = 198;
export const VERFUEGBARAB = 199;
export const LAENDERVERSION = 200;
export const HINTSLOCATION = 201;
export const E10 = 202;
export const VIDEOLINK = 203;
export const BLICKFANG_AS = 204;
export const LEERGEWICHT = 205;
export const AKTEANGELEGT = 206;
export const ID_USER_V = 207;
export const ID_USER_E = 208;
export const TOPINSERAT_AS = 209;
export const ID_KRAFTSTOFF = 210;
export const JAHRESSTEUER = 211;
export const ECE_COM_E = 212;
export const ID_EFFIZIENZ = 213;
export const MMCOLOR = 214;
export const GAENGE = 215;
export const KFZBRIEFSTANDORT = 216;
export const KFZSTANDORT = 217;
export const KFZAUSGANG = 218;
export const KFZEINGANG = 219;
export const AKTIONSFAHRZEUG = 220;
export const SONDERANGEBOT = 221;
export const HINTSAUSO = 226;
export const NICHTRAUCHER = 227;
export const ORIG = 228;
export const ID_GETRIEBE = 229;
export const VK_RES = 230;
export const EK_PLAN = 231;
export const VK_RES2 = 232;
export const REPAIR_PLAN = 233;
export const VK_FINAL = 234;
export const VK_PLAN = 235;
export const DAT_ANGELEGT = 236;
export const INVENTUR = 237;
export const ID_ENGINE = 238;
export const DEALERNO = 239;
export const WV_IN = 240;
export const WV_OUT = 241;
export const TUV_IN = 242;
export const TUV_OUT = 243;
export const DATE_STANDORT = 244;
export const ID_LABEL1 = 245;
export const ID_LABEL2 = 246;
export const ID_INNENFARBE = 247;
export const TOPINSERAT_MOBILE_M = 248;
export const ROTSTIFT_MOBILE = 249;
export const EBAYK_EXPORT = 250;
export const ID_DIMENSION = 251;
export const ID_LOADING_SPACE = 252;
export const EUROPALETTEN = 253;
export const SHIPPING_VOLUME = 254;
export const LADEFLAECHE = 255;

const sCols: SelectDataObject<{ d: string; faktor?: number; inputProps?: DataGridEnrichedColDef; parseDateFormat?: DateFormatString | { to: DateFormatString; tn: DateFormatString } }>[] = [
    { i: 5, d: 'doors', t: 'Türen', inputProps: { headerName: '', field: '', type: 'decimal', min: 0 } },
    { i: 7, d: 'hints', t: 'Bemerkung', inputProps: { headerName: '', field: '', type: 'multiline' } },
    { i: 8, d: 'vorbesitzer', t: 'Vorbesitzer', inputProps: { headerName: '', field: '', type: 'decimal', min: 0 } },
    { i: 9, d: 'farbe', t: 'Außenfarbe', inputProps: { headerName: '', field: '', type: 'singleselect', data: sExtColors } },
    { i: 10, d: 'hintsAus', t: 'Ausstattungsbemerkung Unten', inputProps: { headerName: '', field: '', type: 'multiline' } },
    { i: 11, d: 'damageDesc', t: '' },
    { i: 12, d: 'numberPlate', t: 'Kennzeichen' },
    { i: 13, d: 'vk', t: 'Kundenpreis', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 14, d: 'location' },
    { i: 15, d: 'tsn', t: 'TSN' },
    { i: 16, d: 'chassis', t: 'Fahrgestell-Nr.' },
    { i: 17, d: 'gesamtgewicht', t: 'Zul. Ges.-Gew.[kg]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'kg', min: 0 } },
    { i: 18, d: 'id_modell', t: 'Modell' },
    { i: 20, d: 'hubraum', t: 'Hubraum [ccm]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'cm³', min: 0 } },
    { i: 21, d: 'mwst', t: 'Steuer', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntSteuer(getMwSt()) } },
    { i: 22, d: 'battery', t: 'Batterie', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntBattery } },
    { i: 23, d: 'nutzlast', t: 'Nutzlast [kg]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'km', min: 0 } },
    { i: 24, d: 'id_motor', t: 'Motor-Art' },
    { i: 25, d: 'modell', t: 'Modell' },
    { i: 26, d: 'leistung', t: 'Leistung [kW]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'kW', min: 0 } },
    { i: 27, d: 'hsn', t: 'HSN' },
    { i: 28, d: 'polster', t: 'Polsterung', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntPolster } },
    { i: 29, d: 'hu', t: 'HU (inkl AU)', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'month' } },
    { i: 30, d: 'id_aufbau', t: 'Fahrzeugklasse' },
    { i: 31, d: 'kategorie', t: 'Fahrzeugart', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntKategorie } },
    { i: 32, d: 'lackart', t: 'Lackart', inputProps: { headerName: '', field: '', type: 'singleselect', data: sExtLackart } },
    { i: 33, d: 'auslieferung', t: 'Auslieferung', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 35, d: 'takein', t: 'Zugang (reell)', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 36, d: 'id_hersteller', t: 'Hersteller', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntHersteller } },
    { i: 38, d: 'km', t: 'Kilometerstand', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'km', min: 0 } },
    { i: 39, d: 'garantie', t: 'Garantie', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntGarantie } },
    { i: 40, d: 'ez', t: 'Erstzulassung', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 41, d: 'design', t: 'Ausführung' },
    { i: 42, d: 'designneu', t: 'Ausführung' },
    { i: 43, d: 'pricechange' },
    { i: 45, d: 'optikok', t: 'Optik o.k.', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 46, d: 'nachaquise', t: 'Nachakquise' },
    { i: 47, d: 'preisok', t: 'Preis ausgezeichnet' },
    { i: 49, d: 'huNeu', t: 'HU', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'month' } },
    { i: 53, d: 'vaudis', t: 'Auftragsnr.' },
    { i: 54, d: 'ek', t: 'Einkaufspreis', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 56, d: 'mietwagen', t: 'Mietfahrzeug', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 57, d: 'sitze', t: 'Anzahl Sitze', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'Sitze', min: 0 } },
    { i: 58, d: 'schadstoff', t: 'Abgasnorm' },
    { i: 59, d: 'manufactyear', t: 'Baujahr', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'year' } },
    { i: 60, d: 'siegel', t: 'GW-Siegel', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntSiegel, height: '1em' } },
    { i: 61, d: 'innenfarbe', t: 'Innenfarbe', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntColors } },
    { i: 63, d: 'vkinetn', t: 'Web-Verkaufspreis Netto', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 64, d: 'gekauft', t: 'gekauft' },
    { i: 69, d: 'takeinEst', t: 'Zugang (geplant)', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 70, d: 'achsen', t: 'Achsen', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'Achsen', min: 0 } },
    { i: 71, d: 'modelyear', t: 'Modelljahr', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'year' } },
    { i: 72, d: 'ckey', t: 'Bestellschlüssel' },
    { i: 73, d: 'kfzbrief', t: 'Fahrzeugbrief' },
    { i: 74, d: 'eingangscheck', t: 'Eingangscheck', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 75, d: 'parkplatz', t: 'Schlüsselnr.' },
    { i: 76, d: 'angelegt', t: 'Fahrzeug angelegt' },
    { i: 77, d: 'hersteller', t: 'Hersteller' },
    { i: 78, d: 'typ', t: 'Fahrzeugtyp', inputProps: { headerName: '', field: '', type: 'singleselect', data: fahrzeugtyp } },
    { i: 79, d: 'mbvkey' },
    { i: 81, d: 'usedElseInfo', t: '' },
    { i: 82, d: 'zustand', t: 'Zustand', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntZustand } },
    { i: 83, d: 'scheckheft', t: 'Scheckheft' },
    { i: 84, d: 'last_service', t: 'Letzte Wartung' },
    { i: 85, d: 'last_service_text', t: 'Bemerkungen Letzte Wartung' },
    { i: 87, d: 'emission', t: 'CO2-Emission', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'g/km', min: 0 } },
    { i: 88, d: 'werkstatt', t: 'in Werkstatt', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 89, d: 'technikok', t: 'Technik o.k.', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 90, d: 'aufbereitung', t: 'in Aufbereitung', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 92, d: 'addUsage', t: 'Hereinnahme' },
    { i: 93, d: 'lackiererei', t: 'in Lack', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 94, d: 'valuta', t: 'Valuta' },
    { i: 97, d: 'lackok', t: 'Lack o.k.', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 99, d: 'verfuegbar', t: 'Verkaufsfertig', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 100, d: 'verwendung', t: 'Verwendung', inputProps: { headerName: '', field: '', type: 'singleselect', data: sVerwendung(getIdFirma() === 53880) } },
    { i: 102, d: 'status', t: 'Status' },
    { i: 104, d: 'transfer_plan' },
    { i: 105, d: 'tageszulassung', t: 'Tageszulassung' },
    { i: 106, d: 'antrieb', t: 'Antrieb', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntAntrieb } },
    { i: 108, d: 'quelle' },
    { i: 109, d: 'fahrschule', t: 'Fahrschulfahrzeug', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 110, d: 'basispreis', t: 'Basispreis', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 115, d: 'neupreis', t: 'Neupreis', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 118, d: 'blickfang_mobile', t: 'Blickfang Mobile' },
    { i: 119, d: 'breite', t: 'Breite [mm]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'mm', min: 0 } },
    { i: 121, d: 'fahrbereit', t: 'Fahrbereit', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 122, d: 'date_rechnung_in', t: 'Rechnung', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 123, d: 'nummer_rechnung_in', t: 'Rechnungs-Nr.' },
    { i: 124, d: 'date_rechnung_out', t: 'Rechnung', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 125, d: 'nummer_rechnung_out', t: 'Rechnungs-Nr.' },
    { i: 126, d: 'hoehe', t: 'Höhe [mm]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'mm', min: 0 } },
    { i: 127, d: 'idBankValuta', t: 'Bank Valuta' },
    { i: 128, d: 'id_parent', t: 'id Parent' },
    { i: 129, d: 'kommission', t: 'Kommission', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 130, d: 'laenge', t: 'Länge [mm]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'mm', min: 0 } },
    { i: 131, d: 'lieferzeit', t: 'Lieferzeit [Tage]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'Tage', min: 0 } },
    { i: 133, d: 'minderausstattungen', t: 'Minderausstattungen', inputProps: { headerName: '', field: '', type: 'multiline' } },
    { i: 134, d: 'kosten', t: 'Kosten (gesamt)', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 137, d: 'taxi', t: 'Taxi', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 138, d: 'transfer', t: 'Überführung Netto', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 140, d: 'upload', t: 'Upload', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 141, d: 'verkauft', t: 'Verkaufsdatum', parseDateFormat: { to: 'yyyy-MM-dd HH:mm:ss.S', tn: 'yyyy-MM-dd HH:mm:ss' }, inputProps: { headerName: '', field: '', type: 'datetime' } },
    { i: 143, d: 'rangeExtender', t: 'Reichweitenverlägerung', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 144, d: 'webvk_plan', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 146, d: 'plakette', t: 'Plakette', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntPlakette, height: '1em' } },
    { i: 147, d: 'seiteeins_mobile', t: 'Seite 1 Mobile' },
    { i: 148, d: 'envkv', t: 'EnVKV', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 149, d: 'tradeport' },
    { i: 150, d: 'id_paket', t: 'Detail' },
    { i: 151, d: 'schlafplaetze', t: 'Schlafplätze', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'Plätze', min: 0 } },
    { i: 152, d: 'id_standort', t: 'Standort', inputProps: { headerName: '', field: '', type: 'singleselect', data: getStandorteForSelect() } },
    { i: 155, d: 'radstand', t: 'Radstand [mm]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'mm', min: 0 } },
    { i: 156, d: 'ecode', t: 'ECode' },
    { i: 157, d: 'AktTyp', t: 'Fahrzeugverwendung' },
    { i: 158, d: 'batteryCapacity', t: 'Batteriekapazität', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'kWh', min: 0 } },
    { i: 161, d: 'werkstatt_ex', t: 'in Werkstatt (extern)', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 162, d: 'technikok_ex', t: 'Technik o.k. (extern)', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 163, d: 'oldtimer', t: 'Oldtimer', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 164, d: 'youngtimer', t: 'Youngtimer', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 171, d: 'reifen', t: 'Reifen' },
    { i: 173, d: 'datencheck', t: 'Daten in UWE geprüft', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 174, d: 'vkminn', t: 'Mindest-VK', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 175, d: 'standtage1_rechnung', t: 'Standzeit 1 (Rech.)' },
    { i: 176, d: 'standtage1', t: 'Standzeit gesamt' },
    { i: 177, d: 'standzeit2', t: 'Standzeit 1 (Reell)' },
    { i: 178, d: 'standzeit', t: 'Standzeit gesamt' },
    { i: 179, d: 'kosten_plan', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 180, d: 'vkmin_plan', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 181, d: 'hp1_plan' },
    { i: 182, d: 'hp2_plan' },
    { i: 183, d: 'debitInfo' },
    { i: 185, d: 'zylinder' },
    { i: 188, d: 'virtuell', t: 'Virtuell', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 189, d: 'id_grundfarbe', t: 'Grundfarbe', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntGrundfarbe } },
    { i: 190, d: 'id_owner' },
    { i: 191, d: 'data_xml', t: 'DataXML' },
    { i: 192, d: 'ece_in', t: 'innerorts', inputProps: { headerName: '', field: '', type: 'decimal', unrounded: 1 } },
    { i: 193, d: 'ece_com', t: 'kombiniert', inputProps: { headerName: '', field: '', type: 'decimal', unrounded: 1 } },
    { i: 194, d: 'ece_out', t: 'außerorts', inputProps: { headerName: '', field: '', type: 'decimal', unrounded: 1 } },
    { i: 195, d: 'portal1text' },
    { i: 196, d: 'topinserat_mobile', t: 'Topinserat Mobile' },
    { i: 197, d: 'id_briefStatus', t: 'Brief-Status' },
    { i: 198, d: 'id_user', t: 'id Firma' },
    { i: 199, d: 'verfuegbarab', t: 'Verfügbar ab', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 200, d: 'laenderVersion', t: 'Länderversion' },
    { i: 201, d: 'hintsLocation', t: 'Bemerkungen aus Standortfeld' },
    { i: 202, d: 'e10', t: 'E10 geeignet', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 203, d: 'videolink', t: 'Videolink bei YouTube' },
    { i: 204, d: 'blickfang_as', t: 'Plus-Inserat AS24' },
    { i: 205, d: 'leergewicht', t: 'Leergewicht [kg]', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'kg', min: 0 } },
    { i: 206, d: 'akteAngelegt', t: 'Akte vollständig angelegt', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 207, d: 'id_user_v', t: 'Verkäufer', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntMitarbeiter } },
    { i: 208, d: 'id_user_e', t: 'Einkäufer', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntMitarbeiter } },
    { i: 209, d: 'topinserat_as', t: 'Premium-Inserat AS24' },
    { i: 210, d: 'id_kraftstoff', t: 'Kraftstoff' },
    { i: 211, d: 'jahresSteuer', t: 'Jahressteuer', inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 212, d: 'ece_com_e' },
    { i: 213, d: 'id_effizienz', t: 'Effizienzklasse', inputProps: { headerName: '', field: '', type: 'singleselect', data: effizienzSteps(false), height: '1em' } },
    { i: 214, d: 'mmColor' },
    { i: 215, d: 'gaenge', inputProps: { headerName: '', field: '', type: 'decimal', einheit: 'Gänge', min: 0 } },
    { i: 216, d: 'kfzBriefStandort', t: 'Standort' },
    { i: 217, d: 'kfzStandort', t: 'seit in' },
    { i: 218, d: 'kfzAusgang', t: 'Ausgang' },
    { i: 219, d: 'kfzEingang', t: 'Posteingang' },
    { i: 220, d: 'aktionsfahrzeug', t: 'Aktionsfahrzeug', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 221, d: 'sonderangebot', t: 'Sonderangebot', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 226, d: 'hintsAusO', t: 'Ausstattungsbemerkung Oben', inputProps: { headerName: '', field: '', type: 'multiline' } },
    { i: 227, d: 'nichtraucher', t: 'Nichtraucher-Fzg', inputProps: { headerName: '', field: '', type: 'check' } },
    { i: 228, d: 'orig', t: 'Neupreis', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 229, d: 'id_getriebe', t: 'Getriebeart', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntGetriebe } },
    { i: 230, d: 'vk_res', t: 'Händlerpreis', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 231, d: 'ek_plan', t: 'EK geplant', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 232, d: 'vk_res2', t: 'Händlerpreis 2', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 233, d: 'repair_plan', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 234, d: 'vk_final', t: 'VK bei Verkauf', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 235, d: 'vk_plan', faktor: 0.01, inputProps: { headerName: '', field: '', type: 'currency', unrounded: 2, min: 0 } },
    { i: 236, d: 'dat_angelegt', t: 'Daten in DAT abgefragt' },
    { i: 237, d: 'inventur', t: 'Inventur', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 238, d: 'id_engine', t: 'Motor (ID)' },
    { i: 239, d: 'dealerno', t: 'Dealer No' },
    { i: 240, d: 'wv_in', t: 'in W & V', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 241, d: 'wv_out', t: 'W & V o.k.', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 242, d: 'tuv_in', t: 'in TÜV', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 243, d: 'tuv_out', t: 'TÜV o.k.', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 244, d: 'date_standort', t: 'Standortwechsel', parseDateFormat: 'yyyy-MM-dd', inputProps: { headerName: '', field: '', type: 'date' } },
    { i: 245, d: 'id_label1', t: 'Kraftstoff 1' },
    { i: 246, d: 'id_label2', t: 'Kraftstoff 2' },
    { i: 247, d: 'id_innenfarbe', t: 'Polsterfarbe', inputProps: { headerName: '', field: '', type: 'singleselect', data: sIntColors } },
    { i: 248, d: 'topinserat_mobile_m', t: 'Topinserat Mobile Mobil' },
    { i: 249, d: 'rotstift_mobile', t: 'Rotstiftpreis Mobile' },
    { i: 250, d: 'ebayk_export', t: 'eBay Kleinanzeigen Export' },
    { i: 251, d: 'id_dimension', t: 'Fahrzeug' },
    { i: 252, d: 'id_loading_space', t: 'Laderaum' },
    { i: 253, d: 'europaletten', t: 'Europaletten' },
    { i: 254, d: 'shipping_volume', t: 'Ladevolumen' },
    { i: 255, d: 'ladeflaeche', t: 'Ladefläche' },
    { i: 256, d: 'newService', t: 'Inspektion neu' },
    { i: 257, d: 'lastMaintenanceMileage', t: 'Letzte Wartung - Kilometerstand' },
    { i: 258, d: 'trailerLoadBraked', t: 'Anhängelast gebremst' },
    { i: 259, d: 'trailerLoadUnbraked', t: 'Anhängelast ungebremst' },
    { i: 260, d: 'maxNoseWeight', t: 'Stützlast' },
    { i: 261, d: 'trimline', t: 'Trimline' },
    { i: 262, d: 'modelrange', t: 'Modelrange' },
    { i: 263, d: 'garantie_von', t: 'Garantie von' },
    { i: 263, d: 'garantie_bis', t: 'Garantie bis' },
];
export default sCols;
